import * as React from "react";

import { Box, Typography } from "@material-ui/core";

import { BankAccountForm } from "client/domain/FormBuilder/BankInformation";

export const ManualBankForm: React.FC = () => (
  <BankAccountForm
    fieldSetName="PrimaryBankFieldSet"
    heading={
      <Box mb={2}>
        <Typography variant="body2">
          <strong>
            This is where Afterpay transactions will be processed.
          </strong>
        </Typography>
      </Box>
    }
  />
);
